import { useSelector } from "react-redux";
import Styles from '../Login.module.css'
import { useState } from "react";
import {resetPassword} from '../../api/login'
import { useNavigate } from "react-router-dom";

const ResetPassword = ()=>{
    const username = useSelector((state)=>state.auth.username);
    const [form,setForm] = useState({
        password:'',
        confirmPassword:''
    });

    const [error,setError] = useState('');

    const navigate =  useNavigate();

    //更新pwd状态
    const handlePassword = (event) =>{
       const {name,value} = event.target;
       setForm({
        ...form,
        [name]:value
       })
    }

    const handleSubmit = async (event) =>{
        event.preventDefault();
        const {password,confirmPassword} = form;
        if(password !== confirmPassword){
            alert("密码前后不一致，请重新输入！");
            return;
        }
        //提交表单
        const response = await resetPassword({username,password});
        
        try {
            if(response.data.code===200){
                alert("密码重置成功，请重新登陆！");
                navigate('/login');
            }else{
                setError(response.data.message || "密码重置失败，请稍后再试！");
            }
        } catch (error) {
            setError('网络请求失败，服务器可能未启动');
        }

    }


    return(
        <div>
            <form onSubmit={handleSubmit} className={Styles.common}>
                <input className={Styles.inputWithUsrnameIcon} readOnly="readOnly" placeholder={username}/>
                <input onChange={handlePassword} name="password" value={form.password} type="password" required="required" className={Styles.inputWithPasswordIcon} placeholder="NEW PASSWORD"/>
                <input onChange={handlePassword} name="confirmPassword" value={form.confirmPassword} type="password" required="required" className={Styles.inputWithPasswordIcon} placeholder="CONFIRM NEW PASSWORD"/>
                <button className={Styles.button}>SUBMIT</button>
                {error&&<p style={{color:'red'}}>{error}</p>}
            </form>
        </div>
    )
}

export default ResetPassword
